var DRAWER_KEYS = {
  VERSION_DRAWER: 'VERSION_DRAWER',
  TEST_DRAWER: 'TEST_DRAWER'
};
export default DRAWER_KEYS;